/* eslint-disable */

import { TaxDeductionWorkCategories, VatRate, YearlyChangingNumbers } from "../model";
import { DatelyObject } from "../util/DatelyObject";
import { Dates } from "../util/Dates";

/**
 * Yearly changing numbers. Contains side cost percentages.
 *
 */

export const getYearlyChangingNumbersYears = (refDate: DatelyObject) =>
  [
    {
      "year": 2014,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.0075,
        "unemploymentHigherEmployerPercent": 0.0295,
        "unemploymentWorkerPercent": 0.005,
        "unemploymentPartialOwnerWorkerPercent": 0.0019,
        "tyelIncomeLimit": 56.55,
        "tyelBasePercent": 0.242,
        "tyelWorkerPercent": 0.0555,
        "tyel53Percent": 0.0705,
        "tyelContractEmployerLimit": 8100.0,
        "socSecPercent": 0.0214,
        "illnessInsurancePercent": 0.0216,
        "healthInsuranceMedicalCareContribution": 0.0132,
        "healthInsuranceDailyAllowanceContribution": 0.0084
      }
    },
    {
      "year": 2015,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.008,
        "unemploymentHigherEmployerPercent": 0.0315,
        "unemploymentWorkerPercent": 0.0065,
        "unemploymentPartialOwnerWorkerPercent": 0.0024,
        "tyelIncomeLimit": 57.1,
        "tyelBasePercent": 0.247,
        "tyelWorkerPercent": 0.057,
        "tyel53Percent": 0.072,
        "tyelContractEmployerLimit": 8178.0,
        "socSecPercent": 0.0208,
        "illnessInsurancePercent": 0.021,
        "healthInsuranceMedicalCareContribution": 0.0132,
        "healthInsuranceDailyAllowanceContribution": 0.0078
      }
    },
    {
      "year": 2016,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.01,
        "unemploymentHigherEmployerPercent": 0.039,
        "unemploymentWorkerPercent": 0.0115,
        "unemploymentPartialOwnerWorkerPercent": 0.0046,
        "tyelIncomeLimit": 57.51,
        "tyelBasePercent": 0.251,
        "tyelWorkerPercent": 0.057,
        "tyel53Percent": 0.072,
        "tyelContractEmployerLimit": 8238.0,
        "socSecPercent": 0.0212,
        "illnessInsurancePercent": 0.0212,
        "healthInsuranceMedicalCareContribution": 0.013,
        "healthInsuranceDailyAllowanceContribution": 0.0082
      }
    },
    {
      "year": 2017,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.008,
        "unemploymentHigherEmployerPercent": 0.033,
        "unemploymentWorkerPercent": 0.016,
        "unemploymentPartialOwnerWorkerPercent": 0.007,
        "tyelIncomeLimit": 58.19,
        "tyelBasePercent": 0.251,
        "tyelWorkerPercent": 0.0615,
        "tyel53Percent": 0.0765,
        "tyelContractEmployerLimit": 8334.0,
        "socSecPercent": 0.0108,
        "illnessInsurancePercent": 0.0158,
        "healthInsuranceMedicalCareContribution": 0.0,
        "healthInsuranceDailyAllowanceContribution": 0.0158
      }
    },
    {
      "year": 2018,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.0065,
        "unemploymentHigherEmployerPercent": 0.026,
        "unemploymentWorkerPercent": 0.019,
        "unemploymentPartialOwnerWorkerPercent": 0.0078,
        "tyelIncomeLimit": 58.27,
        "tyelBasePercent": 0.253,
        "tyelWorkerPercent": 0.0635,
        "tyel53Percent": 0.0785,
        "tyelContractEmployerLimit": 8346.0,
        "socSecPercent": 0.0086,
        "illnessInsurancePercent": 0.0153,
        "healthInsuranceMedicalCareContribution": 0.0,
        "healthInsuranceDailyAllowanceContribution": 0.0153,
        "taxFreeDailyAllowance": 42,
        "taxFreeDailyHalfAllowance": 19,
        "taxFreeMealAllowance": 10.5,
        "taxFreeKmAllowance": 0.42,
        "unionPaymentRaksaA": 0.0155,
        "unionPaymentRaksaAoTa": 0.0055,
        "stepsTaxCardLimit1": 10500,
        "stepsTaxCardLimit2": 17950,
        "householdDeduction": 0.20,
      }
    },
    {
      "year": 2019,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.005,
        "unemploymentHigherEmployerPercent": 0.0205,
        "unemploymentWorkerPercent": 0.015,
        "unemploymentPartialOwnerWorkerPercent": 0.0078,
        "tyelIncomeLimit": 59.36,
        "tyelBasePercent": 0.252,
        "tyelWorkerPercent": 0.0675,
        "tyel53Percent": 0.0825,
        "tyelContractEmployerLimit": 8502.0,
        "socSecPercent": 0.0077,
        "illnessInsurancePercent": 0.0154,
        "healthInsuranceMedicalCareContribution": 0.0,
        "healthInsuranceDailyAllowanceContribution": 0.0154,
        "taxFreeDailyAllowance": 42,
        "taxFreeDailyHalfAllowance": 19,
        "taxFreeMealAllowance": 10.5,
        "taxFreeKmAllowance": 0.43,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "stepsTaxCardLimit1": 10500,
        "stepsTaxCardLimit2": 17950,
        "householdDeduction": 0.20,
      }
    },
    {
      "year": 2020,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.0045,
        "unemploymentHigherEmployerPercent": 0.017,
        "unemploymentWorkerPercent": 0.0125,
        "unemploymentPartialOwnerWorkerPercent": 0.0065,
        "tyelIncomeLimit": 60.57,
        "tyelBasePercent": 0.253,
        "tyelWorkerPercent": 0.0715,
        "tyel53Percent": 0.0865,
        "tyelContractEmployerLimit": 8676.0,
        "socSecPercent": 0.0134,
        "illnessInsurancePercent": 0.0186,
        "healthInsuranceMedicalCareContribution": 0.0068,
        "healthInsuranceDailyAllowanceContribution": 0.0118,
        "taxFreeDailyAllowance": 43.0,
        "taxFreeDailyHalfAllowance": 20.0,
        "taxFreeMealAllowance": 10.75,
        "taxFreeKmAllowance": 0.43,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "palkkausVatPercent": 0.24,
        "householdDeduction": 0.15,
        "mealBenefitCateringContract": 6.8,
        "mealBenefitInstitute": 5.1,
        "mealBenefitRestaurantWorker": 5.78,
        "mealBenefitTeacher": 4.08,
        "mealTicketLowerLimit": 6.8,
        "mealTicketUpperLimit": 10.7,
        "mealTicketTaxable": 0.75,
        "protectedPortionBase": 22.63,
        "protectedPortionDependant": 8.12
      },
    },
    {
      "year": 2021,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.005,
        "unemploymentHigherEmployerPercent": 0.019,
        "unemploymentWorkerPercent": 0.014,
        "unemploymentPartialOwnerWorkerPercent": 0.0065,
        "tyelIncomeLimit": 61.37,
        "tyelBasePercent": 0.248,
        "tyelWorkerPercent": 0.0715,
        "tyel53Percent": 0.0865,
        "tyelContractEmployerLimit": 8790.0,
        "socSecPercent": 0.0153,
        "illnessInsurancePercent": 0.0204,
        "healthInsuranceMedicalCareContribution": 0.0068,
        "healthInsuranceDailyAllowanceContribution": 0.0136,
        "taxFreeDailyAllowance": 44.0,
        "taxFreeDailyHalfAllowance": 20.0,
        "taxFreeMealAllowance": 11.0,
        "taxFreeKmAllowance": 0.44,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "palkkausVatPercent": 0.24,
        "householdDeduction": 0.15,
        "householdDeductionMaxAmount": 2250,
        "householdDeductionDeductible": 100,
        "mealBenefitCateringContract": 6.9,
        "mealBenefitInstitute": 5.18,
        "mealBenefitRestaurantWorker": 5.87,
        "mealBenefitTeacher": 4.14,
        "mealTicketLowerLimit": 6.9,
        "mealTicketUpperLimit": 10.9,
        "mealTicketTaxable": 0.75,
        "protectedPortionBase": 22.71,
        "protectedPortionDependant": 8.15
      },
    },
    {
      "year": 2022,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.005,
        "unemploymentHigherEmployerPercent": 0.0205,
        "unemploymentWorkerPercent": 0.015,
        "unemploymentPartialOwnerWorkerPercent": 0.0074,
        "tyelIncomeLimit": 62.88,
        "tyelBasePercent": 0.2585,
        "tyelWorkerPercent": 0.0715,
        "tyel53Percent": 0.0865,
        "tyelContractEmployerLimit": 9006.0,
        "socSecPercent": 0.0134,
        "illnessInsurancePercent": 0.0171,
        "healthInsuranceMedicalCareContribution": 0.0053,
        "healthInsuranceDailyAllowanceContribution": 0.0118,
        "taxFreeBicycleBenefit": 1200,
        "taxFreeDailyAllowance": 45.0,
        "taxFreeDailyHalfAllowance": 20.0,
        "taxFreeMealAllowance": 11.25,
        "taxFreeKmAllowance": 0.46,
        "taxFreeSubsidisedCommute": 3400,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "palkkausVatPercent": 0.24,
        "householdDeduction": 0.15,
        "householdDeductionExtended": 0.30,
        "householdDeductionMaxAmount": 2250,
        "householdDeductionMaxAmountExtended": 3500,
        "householdDeductionDeductible": 100,
        "householdDeductionCategoriesExtended": [
          TaxDeductionWorkCategories.Householdwork,
          TaxDeductionWorkCategories.Carework,
          TaxDeductionWorkCategories.OilHeatingReplacementWork
        ],
        "mealBenefitCateringContract": 7.15,
        "mealBenefitInstitute": 5.36,
        "mealBenefitRestaurantWorker": 6.08,
        "mealBenefitTeacher": 4.29,
        "mealTicketLowerLimit": 7.15,
        "mealTicketUpperLimit": 11.30,
        "mealTicketTaxable": 0.75,
        "protectedPortionBase": 23.20,
        "protectedPortionDependant": 8.34
      },
    },
    {
      "year": 2023,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.0052,
        "unemploymentHigherEmployerPercent": 0.0206,
        "unemploymentWorkerPercent": 0.015,
        "unemploymentPartialOwnerWorkerPercent": 0.0075,
        "tyelIncomeLimit": 65.26,
        "tyelBasePercent": 0.262,
        "tyelWorkerPercent": 0.0715,
        "tyel53Percent": 0.0865,
        "tyelContractEmployerLimit": 9348.0,
        "socSecPercent": 0.0153,
        "illnessInsurancePercent": 0.0196,
        "healthInsuranceMedicalCareContribution": 0.006,
        "healthInsuranceDailyAllowanceContribution": 0.0136,
        "taxFreeBicycleBenefit": 1200,
        "taxFreeDailyAllowance": 48.0,
        "taxFreeDailyHalfAllowance": 22.0,
        "taxFreeMealAllowance": 12.00,
        "taxFreeKmAllowance": 0.53,
        "taxFreeSubsidisedCommute": 3400,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "palkkausVatPercent": 0.24,
        "householdDeduction": 0.15,
        "householdDeductionExtended": 0.30,
        "householdDeductionMaxAmount": 2250,
        "householdDeductionMaxAmountExtended": 3500,
        "householdDeductionDeductible": 100,
        "householdDeductionCategoriesExtended": [
          TaxDeductionWorkCategories.Householdwork,
          TaxDeductionWorkCategories.Carework,
          TaxDeductionWorkCategories.OilHeatingReplacementWork
        ],
        "mealBenefitCateringContract": 8.00,
        "mealBenefitInstitute": 6.00,
        "mealBenefitRestaurantWorker": 6.80,
        "mealBenefitTeacher": 4.80,
        "mealTicketLowerLimit": 8.00,
        "mealTicketUpperLimit": 12.70,
        "mealTicketTaxable": 0.75,
        "protectedPortionBase": 30.75,
        "protectedPortionDependant": 8.99
      },
    },
    {
      "year": 2024,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.0027,
        "unemploymentHigherEmployerPercent": 0.0109,
        "unemploymentWorkerPercent": 0.0079,
        "unemploymentPartialOwnerWorkerPercent": 0.0043,
        "tyelIncomeLimit": 68.57,
        "tyelBasePercent": 0.2612,
        "tyelWorkerPercent": 0.0715,
        "tyel53Percent": 0.0865,
        "tyelContractEmployerLimit": 9822.0,
        "socSecPercent": 0.0116,
        "illnessInsurancePercent": 0.0152,
        "healthInsuranceMedicalCareContribution": 0.0051,
        "healthInsuranceDailyAllowanceContribution": 0.0101,
        "taxFreeDailyAllowance": 51.0,
        "taxFreeDailyHalfAllowance": 24.0,
        "taxFreeMealAllowance": 12.75,
        "taxFreeBicycleBenefit": 1200.0,
        "taxFreeSubsidisedCommute": 3400.0,
        "taxFreeKmAllowance": 0.57,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "palkkausVatPercent": Dates.isSameOrAfter(refDate, "2024-09-01") ? 0.255 : 0.24,
        "palkkausVatRate": Dates.isSameOrAfter(refDate, "2024-09-01") ? VatRate.Vat2550 : VatRate.Vat2400,
        "householdDeduction": 0.15,
        "householdDeductionExtended": 0.3,
        "householdDeductionMaxAmount": 2250.0,
        "householdDeductionMaxAmountExtended": 3500.0,
        "householdDeductionCategoriesExtended": [
           TaxDeductionWorkCategories.Householdwork,
           TaxDeductionWorkCategories.Carework,
           TaxDeductionWorkCategories.OilHeatingReplacementWork
        ],
        "householdDeductionDeductible": 100.0,
        "mealBenefitCateringContract": 8.5,
        "mealBenefitInstitute": 6.37,
        "mealBenefitRestaurantWorker": 7.22,
        "mealBenefitTeacher": 5.1,
        "mealTicketLowerLimit": 8.5,
        "mealTicketUpperLimit": 13.5,
        "mealTicketTaxable": 0.75,
        "protectedPortionBase": 32.56,
        "protectedPortionDependant": 9.52
      },
    },
    {
      "year": 2025,
      "sideCosts": {
        "unemploymentEmployerPercent": 0.002,
        "unemploymentHigherEmployerPercent": 0.008,
        "unemploymentWorkerPercent": 0.0059,
        "unemploymentPartialOwnerWorkerPercent": 0.003,
        "tyelIncomeLimit": 70.08,
        "tyelBasePercent": 0.2628,
        "tyelWorkerPercent": 0.0715,
        "tyel53Percent": 0.0865,
        "tyelContractEmployerLimit": 10038.0,
        "socSecPercent": 0.0187,
        "illnessInsurancePercent": 0.019,
        "healthInsuranceMedicalCareContribution": 0.0106,
        "healthInsuranceDailyAllowanceContribution": 0.0084,
        "taxFreeDailyAllowance": 53.0,
        "taxFreeDailyHalfAllowance": 24.0,
        "taxFreeMealAllowance": 13.25,
        "taxFreeBicycleBenefit": 1200.0,
        "taxFreeSubsidisedCommute": 3400.0,
        "taxFreeKmAllowance": 0.59,
        "unionPaymentRaksaA": 0.0149,
        "unionPaymentRaksaAoTa": 0.0052,
        "palkkausVatPercent": 0.255,
        "palkkausVatRate": VatRate.Vat2550,
        "householdDeduction": 0.13,
        "householdDeductionExtended": 0.3,
        "householdDeductionMaxAmount": 1600.0,
        "householdDeductionMaxAmountExtended": 3500.0,
        "householdDeductionCategoriesExtended": [
          TaxDeductionWorkCategories.OilHeatingReplacementWork
        ],
        "householdDeductionDeductible": 150.0,
        "mealBenefitCateringContract": 8.6,
        "mealBenefitInstitute": 6.45,
        "mealBenefitRestaurantWorker": 7.31,
        "mealBenefitTeacher": 5.16,
        "mealTicketLowerLimit": 8.6,
        "mealTicketUpperLimit": 13.7,
        "mealTicketTaxable": 0.75,
        "protectedPortionBase": 32.88,
        "protectedPortionDependant": 9.61
      }
    }
  ] as any as YearlyChangingNumbers[];
